export default function Sparkline({
  values,
  width = 120,
  height = 28,
  stroke = 'var(--c-sage)',
  fill = true,
}: {
  values: number[];
  width?: number;
  height?: number;
  stroke?: string;
  fill?: boolean;
}) {
  const safeVals = (Array.isArray(values) ? values : []).map((v) => Number(v) || 0);
  if (!safeVals.length) return <svg width={width} height={height} />;
  const max = Math.max(...safeVals, 1);
  const min = Math.min(...safeVals, 0);
  const range = max - min || 1;
  const step = safeVals.length > 1 ? width / (safeVals.length - 1) : width;
  const pts = safeVals.map((v, i) => ({
    x: i * step,
    y: height - 3 - ((v - min) / range) * (height - 6),
  }));
  const d = pts.map((p, i) => (i === 0 ? 'M' : 'L') + p.x.toFixed(1) + ' ' + p.y.toFixed(1)).join(' ');
  const fillD = d + ` L ${width} ${height} L 0 ${height} Z`;
  return (
    <svg width={width} height={height} style={{ display: 'block', overflow: 'visible' }}>
      {fill && <path d={fillD} fill={stroke} opacity="0.12" />}
      <path d={d} fill="none" stroke={stroke} strokeWidth="1.8" strokeLinecap="round" />
      <circle cx={pts[pts.length - 1].x} cy={pts[pts.length - 1].y} r="2.5" fill={stroke} />
    </svg>
  );
}
